import { createMuiTheme } from '@material-ui/core';

import Device from 'constants/deviceSizes';
import { appConfig } from 'config/customization';

export const theme = createMuiTheme({
  overrides: {
    MuiInput: {
      input: {
        fontFamily: appConfig.fontFamily,
        fontSize: 14
      },
      underline: {
        '&:hover:not($disabled):not($focused):not($error):before': {
          borderBottom: `1px solid ${appConfig.colors.grey}`
        },
        '&$disabled:before': {
          borderBottom: `1px solid ${appConfig.colors.grey}`
        },
        '&$focused:after': {
          borderBottom: `2px solid ${appConfig.colors.primary}`
        },
        '&:after': {
          borderBottom: `2px solid ${appConfig.colors.primary}`
        }
      }
    },
    MuiFormLabel: {
      root: {
        '&$error': {
          color: appConfig.colors.grey
        },
        '&$focused': {
          color: appConfig.colors.primary,
          '&$error': {
            color: appConfig.colors.error
          }
        },
        fontFamily: appConfig.fontFamily,
        fontSize: 14
      }
    }
  }
});

export default {
  container: {
    display: 'flex',
    flexDirection: 'row-reverse',
    flexShrink: 0,
    justifyContent: 'center',
    width: '100%',
    [Device.mobile]: {
      flexDirection: 'column',
      marginTop: 20
    }
  },
  field: {
    marginTop: 20,
    minWidth: 385
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 20,
    minWidth: 385
  },
  minField: {
    width: '46%'
  },
  fields: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: 15,
    [Device.mobile]: {
      marginRight: 0,
      marginTop: 15,
      width: '100%'
    }
  }
};
